import React from 'react';
import PropTypes from 'prop-types';

import { Link as v4Link } from 'react-router-dom';

// Multibrand-UI Components
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import CaretLeft from '@zg-rentals/multibrand-ui/lib/icons/CaretLeft';

// TODO: update mui Row, Col to use zrs-comet
import { Container } from '@zillow/zrs-comet';

import './style.scss';

const propTypes = {
    title: PropTypes.string,
    redirectTo: PropTypes.string.isRequired,
};

const defaultProps = {
    title: '',
};

const Breadcrumb = ({ redirectTo, title }) => (
    <Container className="Breadcrumb">
        <Row>
            <Col>
                <Link reactRouterLink={v4Link} to={redirectTo}>
                    <CaretLeft size={14} />
                    <Text type="body">{title}</Text>
                </Link>
            </Col>
        </Row>
    </Container>
);

Breadcrumb.propTypes = propTypes;
Breadcrumb.defaultProps = defaultProps;

export default Breadcrumb;
